module.exports = __webpack_public_path__ + "static/media/product-hosting.a30ceec8.png";